import styled, { css } from 'foundations-theming/utils';
export const ModuleRenderedContainer = styled.div.withConfig({
  displayName: "ModuleRenderedContainer"
})(({
  renderingModule,
  isInPositioner
}) => {
  return css(["min-height:", ";pointer-events:none;", ""], renderingModule ? '20px' : '2px', isInPositioner && renderingModule && css(["opacity:0;position:absolute;top:0;width:100%;left:0;"]));
});